import { TranslateService } from "@ngstack/translate";
import { Component, OnInit } from "@angular/core";


@Component({
  selector: "app-term-info",
  templateUrl: "./term-info.component.html",
  styleUrls: ["./term-info.component.css"]
})
export class TermInfoComponent implements OnInit {
  constructor(public translate: TranslateService) {}

  ngOnInit() {}
}
